var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilters = function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373635",
    d: "M8.437 1.5H24.5a.5.5 0 0 1 0 1H8.437a2 2 0 0 1-3.874 0H.5a.5.5 0 0 1 0-1h4.063a2 2 0 0 1 3.874 0M.5 9.5a.5.5 0 0 0 0 1h13.063a2 2 0 0 0 3.874 0H24.5a.5.5 0 0 0 0-1h-7.063a2 2 0 0 0-3.874 0zM0 18a.5.5 0 0 1 .5-.5h7.063a2 2 0 0 1 3.874 0H24.5a.5.5 0 0 1 0 1H11.437a2 2 0 0 1-3.874 0H.5A.5.5 0 0 1 0 18"
  })));
};
export default SvgFilters;